module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/.6.18.0@babel-runtime/core-js/array/from.js
 ** module id = 527
 ** module chunks = 0
 **/